(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  var btn = document.getElementById('dodo-load-more-btn');
  var wrap = document.getElementById('dodo-load-more-wrap');
  var grid = document.querySelector('.dodo-collection-grid');

  if (!btn || !grid) return;

  var currentPage = 1;
  var totalPages = parseInt(btn.dataset.totalPages) || 1;
  var sectionId = btn.dataset.sectionId || '';

  btn.addEventListener('click', function () {
    btn.disabled = true;
    btn.textContent = 'Loading...';

    var nextPage = currentPage + 1;
    var url = window.location.pathname + '?page=' + nextPage + '&section_id=' + sectionId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.dodo-collection-card');

        newCards.forEach(function (card) {
          card.style.animationDelay = '0ms';
          grid.appendChild(card);
        });

        currentPage = nextPage;

        if (currentPage >= totalPages) {
          wrap.remove();
        } else {
          btn.disabled = false;
          btn.textContent = 'Show More';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Show More';
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
